import CuratenieDupaEvenimente from "pages/Servicii/ServiciiSpeciale/CuratenieDupaEvenimente";

export default function CuratenieDupaEvenimentePage() {
    return <CuratenieDupaEvenimente />;
}
